import React, { useEffect, useState } from 'react'
import './CustomPlan.css'
import SelectPlan from './Views/SelectPlan'
import Payment from './Views/Payment';
import axios from 'axios';

export default function CustomPlan() {
    const [currentPage, setCurrentPage] = useState("selectPlan");
    const [specs, setSpecs] = useState();
    const [selectedTitle, setSelectedTitle] = useState("");
    const [selectedLabel, setSelectedLabel] = useState("");
    const [selectedPrice, setSelectedPrice] = useState("");
    const [selectedPriceNumeric, setSelectedPriceNumeric] = useState(0);
    const [userCountry, setUserCountry] = useState("");

    useEffect(() => {
        axios.get('https://api.ipify.org?format=json')
            .then(res => {
                const userIP = res.data.ip;
                return axios.get(`https://api.ipdata.co/${userIP}?api-key=e079e8cc30eccf8ecde4af4981b90f6cb44d46b3b095fdb921fcea6c`);
            })
            .then(res => {
                setUserCountry(res.data.country_name)
            })
            .catch(err => console.error(err));
    }, []);

    return (
        <>
            {currentPage === "selectPlan" && <SelectPlan userCountry={userCountry} setCurrentPage={setCurrentPage} setSpecs={setSpecs} setSelectedPrice={setSelectedPrice} setSelectedTitle={setSelectedTitle} setSelectedPriceNumeric={setSelectedPriceNumeric} setSelectedLabel={setSelectedLabel} />}
            {currentPage === "payment" && <Payment setCurrentPage={setCurrentPage} specs={specs} title={selectedTitle} price={selectedPrice} userCountry={userCountry} selectedPriceNumeric={selectedPriceNumeric} selectedLabel={selectedLabel}/>}
        </>
    )
}
